import React from "react";
import { Helmet } from "react-helmet";

import GridImage1 from "../../assets/images/png/grids/image1.webp";
import GridImage2 from "../../assets/images/png/grids/image2.webp";
import GridImage3 from "../../assets/images/png/grids/image3.webp";
import GridImage4 from "../../assets/images/png/grids/image4.webp";
import GridImage5 from "../../assets/images/png/grids/image5.webp";
import GridImage6 from "../../assets/images/png/grids/image6.webp";
import GridImage7 from "../../assets/images/png/grids/image7.webp";
import GridImage8 from "../../assets/images/png/grids/image8.webp";
import DriveSection from "./components/driveSection";
import EligibilitySection from "./components/eligibilitySection";
import GoalSection from "./components/goalSection";
import ImageSection from "./components/imageSection";
import NewsSection from "./components/newsSection";
import PurposeSection from "./components/purposeSection";
import StatSection from "./components/statSection";
import SupportSection from "./components/supportSection";
import TopSection from "./components/topSection";
import SiteFooter from "../../components/layout/SiteFooter";

const Binancecharity = () => {
  return (
    <div>
      <Helmet>
        <title>Utiva | Binance</title>
      </Helmet>
      <TopSection />
      <ImageSection
        image1={GridImage1}
        image2={GridImage2}
        image3={GridImage3}
        image4={GridImage4}
      />
      <StatSection />
      <EligibilitySection />
      <GoalSection />
      <DriveSection />
      <ImageSection
        image1={GridImage5}
        image2={GridImage6}
        image3={GridImage7}
        image4={GridImage8}
      />
      <PurposeSection />
      <SupportSection />
      <NewsSection />

      <SiteFooter />
    </div>
  );
};

export default Binancecharity;
